(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 73700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(2040);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32909);


function FormsLogo() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "d-flex justify-content-center margin_bottom-24",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons__WEBPACK_IMPORTED_MODULE_1__/* .LogoBig */ .$T, {})
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormsLogo);


/***/ }),

/***/ 76931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36968);


function Loader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "#ffffffab",
            zIndex: 9998
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                position: "fixed",
                top: "45%",
                left: "50%",
                textAlign: "center",
                zIndex: 9999
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                animation: "border",
                role: "status",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "visually-hidden",
                    children: "Loading..."
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 57282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ EMAIL_VALIDATOR; },
/* harmony export */   "oq": function() { return /* binding */ DOCUMENT_EXTENSIONS; }
/* harmony export */ });
/* unused harmony export IMAGE_EXTENSIONS */
var EMAIL_VALIDATOR = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
var DOCUMENT_EXTENSIONS = ".pdf,.csv,.doc,.docx,.xlsx,.txt,.jpg,.jpeg,.png,.heic";
var IMAGE_EXTENSIONS = ".jpg,.jpeg,.png";


/***/ }),

/***/ 53567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ authGuard; },
  "k": function() { return /* reexport */ unAuthGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/helpers/hoc/unAuthGuard.tsx


function withOutAuth(WrapperComponent) {
    return function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperComponent, (0,_object_spread/* default */.Z)({}, props));
    };
}
/* harmony default export */ var unAuthGuard = (withOutAuth);

;// CONCATENATED MODULE: ./src/helpers/hoc/authGuard.tsx


function withAuth(WrapperComponent) {
    return function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperComponent, (0,_object_spread/* default */.Z)({}, props));
    };
}
/* harmony default export */ var authGuard = (withAuth);

;// CONCATENATED MODULE: ./src/helpers/hoc/index.ts




/***/ }),

/***/ 2324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useFormBackground; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useFormBackground() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.body.classList.add("form_background");
        return function() {
            document.body.classList.remove("form_background");
        };
    }, []);
}


/***/ }),

/***/ 2040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(4266);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(74119);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(35005);
/* harmony import */ var src_components_FormsLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5283);
/* harmony import */ var src_components_Loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76931);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_config_validators__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(57282);
/* harmony import */ var src_requests_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19795);
/* harmony import */ var src_utils_nookies__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69918);
/* harmony import */ var src_helpers_hooks_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2324);
/* harmony import */ var src_helpers_hoc__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53567);
/* harmony import */ var src_components_Metadata__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49499);
/* harmony import */ var src_helpers_hooks_user__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50364);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86501);

















function Login() {
    (0,src_helpers_hooks_auth__WEBPACK_IMPORTED_MODULE_8__/* .useFormBackground */ .b)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), working = ref[0], setWorking = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isEmailInvalid = ref2[0], setIsEmailInvalid = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), password = ref3[0], setPassword = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loggedIn = ref4[0], setLoggedIn = ref4[1];
    var auth = (0,src_helpers_hooks_user__WEBPACK_IMPORTED_MODULE_11__/* .useUserData */ .v)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        auth.logout();
        console.log("auth logout");
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref, ref1;
        // route topp
        var is_topp = (ref1 = (ref = auth.user) === null || ref === void 0 ? void 0 : ref.organizations[0]) === null || ref1 === void 0 ? void 0 : ref1.is_topp;
        if (is_topp) {
            (0,src_requests_auth__WEBPACK_IMPORTED_MODULE_6__/* .getToppLink */ .IP)();
            router.replace("tpp");
        } else if (!auth.validating && !auth.error && !!auth.user && loggedIn && !(auth === null || auth === void 0 ? void 0 : auth.is_topp)) {
            router.replace("dashboard");
        }
    }, [
        auth.validating,
        auth.error,
        auth.user,
        loggedIn
    ]);
    console.log(isEmailInvalid);
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var data, ref, ref1;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        _ctx.prev = 1;
                        setWorking(true);
                        _ctx.next = 5;
                        return (0,src_requests_auth__WEBPACK_IMPORTED_MODULE_6__/* .loginWithEmailPassword */ .WI)(email, password);
                    case 5:
                        data = _ctx.sent.data;
                        if (data === null || data === void 0 ? void 0 : data.is_topp) {
                            (0,src_utils_nookies__WEBPACK_IMPORTED_MODULE_7__/* .setLiteTokens */ .Ky)(data === null || data === void 0 ? void 0 : data.refresh);
                        } else {
                            (0,src_utils_nookies__WEBPACK_IMPORTED_MODULE_7__/* .setAuthTokens */ .vD)(data === null || data === void 0 ? void 0 : data.refresh, data === null || data === void 0 ? void 0 : data.access);
                        }
                        auth.mutate();
                        setLoggedIn(true);
                        _ctx.next = 15;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        if ((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) == "No active account found with the given credentials") {
                            react_hot_toast__WEBPACK_IMPORTED_MODULE_13__/* ["default"].error */ .ZP.error("This email and password combination is incorrect.", {
                                style: {
                                    backgroundColor: "#fff0ec",
                                    borderColor: "#fa6440",
                                    fontWeight: 300,
                                    color: "#fa6440",
                                    textAlign: "center"
                                }
                            });
                        }
                    case 15:
                        _ctx.prev = 15;
                        setWorking(false);
                        return _ctx.finish(15);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    15,
                    18
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "loginForm",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Metadata__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                title: "Quick Organic Login"
            }),
            working && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            className: "form_login color_bg-white color_border-gray--08",
                            onSubmit: function(e) {
                                return handleSubmit(e);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_FormsLogo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            controlId: "loginFloatingEmail",
                                            label: "Email Address",
                                            className: "mb-3 " + (email ? "para-7" : "para-5"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Control */ .Z.Control, {
                                                type: "email",
                                                placeholder: "Email Address",
                                                name: "email",
                                                className: "form_input para-5 login_email-invalid",
                                                value: email,
                                                onChange: function(param) {
                                                    var target = param.target;
                                                    var newEmail = target.value;
                                                    setEmail(newEmail);
                                                    if (newEmail.trim() === "") {
                                                        setIsEmailInvalid(false);
                                                    } else {
                                                        emailPattern.test(newEmail) ? setIsEmailInvalid(false) : setIsEmailInvalid(true);
                                                    }
                                                }
                                            })
                                        }),
                                        isEmailInvalid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "para-6 color_text-secondary fw-400",
                                            children: "Please enter a valid email address"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            controlId: "loginFloatingPassword",
                                            label: "Password",
                                            className: "mb-3 " + (password ? "para-7" : "para-5"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Control */ .Z.Control, {
                                                type: "password",
                                                placeholder: "Password",
                                                name: "password",
                                                className: "form_input para-5",
                                                value: password,
                                                onChange: function(param) {
                                                    var target = param.target;
                                                    return setPassword(target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            variant: "primary w-100",
                                            type: "submit",
                                            className: "form_btn para-5 fw-300",
                                            disabled: !src_config_validators__WEBPACK_IMPORTED_MODULE_21__/* .EMAIL_VALIDATOR.test */ .B1.test(email) || !password,
                                            children: "Log In"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "text-center",
                                            style: {
                                                marginTop: "1.5em"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                href: "/forget-password",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "para-5 fw-300 color_text-primary link_hover link_underline-none",
                                                    children: "Forgot Password?"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                            className: "fw-400 color_text-gray--01 text-center para-5",
                                            style: {
                                                marginTop: "1.5em"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    className: "fw-300 color_text-gray--01 para-5",
                                                    children: "No account?"
                                                }),
                                                "\xa0",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                    href: "/signup",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        className: "para-5 fw-300 color_text-primary link_hover link_underline-none",
                                                        children: "Create one"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "text-center",
                                            style: {
                                                marginTop: "1.5em"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                href: "/help",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "para-5 fw-300 color_text-primary link_hover link_underline-none",
                                                    children: "Need help?"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = ((0,src_helpers_hoc__WEBPACK_IMPORTED_MODULE_9__/* .withOutAuth */ .k)(Login));


/***/ }),

/***/ 10682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  fluid: false
};
const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 21608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;

    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }

    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5231,8759,5799,9774,2888,179], function() { return __webpack_exec__(73700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);